// extracted by mini-css-extract-plugin
module.exports = {"channelbox":"styles_channelbox__1HnqS","wrapper":"styles_wrapper__Z5-6M"};